import React from 'react';
import { 
  Box, 
  Container, 
  Heading, 
  Text, 
  VStack, 
  Button, 
  Icon, 
  useColorModeValue 
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FiXCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../../../components/v0/PageLayout';

/**
 * 支付取消页面
 * 当用户取消Stripe Checkout支付流程时，Stripe将重定向到此页面
 */
const SubscriptionCancel: React.FC = () => {
  const { t } = useTranslation(['v0/subscription', 'v0/common']);
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  
  return (
    <PageLayout title={t('v0/subscription:cancel.pageTitle')}>
      <Box bg={bgColor} minH="calc(100vh - 64px)" py={10}>
        <Container maxW="container.md">
          <VStack
            spacing={8}
            bg={cardBg}
            p={10}
            borderRadius="lg"
            boxShadow="md"
            align="center"
            textAlign="center"
          >
            <Icon as={FiXCircle} w={20} h={20} color="red.500" />
            
            <Heading as="h1" size="xl">
              {t('v0/subscription:cancel.title')}
            </Heading>
            
            <Text fontSize="lg">
              {t('v0/subscription:cancel.message')}
            </Text>
            
            <Text color="gray.500">
              {t('v0/subscription:cancel.detail')}
            </Text>
            
            <VStack spacing={4} pt={4}>
              <Button 
                as={RouterLink} 
                to="/subscription" 
                colorScheme="primary" 
                size="lg"
              >
                {t('v0/subscription:cancel.tryAgain')}
              </Button>
              
              <Button 
                as={RouterLink} 
                to="/" 
                variant="outline"
              >
                {t('v0/common:actions.backToHome')}
              </Button>
            </VStack>
          </VStack>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default SubscriptionCancel; 